var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-table-cell data-box"},_vm._l((_vm.text),function(content,i){return _c('p',{key:i},[_vm._v(" "+_vm._s(content)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }